import { render, staticRenderFns } from "./UpgradeModal.vue?vue&type=template&id=d25e212c&scoped=true&"
import script from "./UpgradeModal.vue?vue&type=script&lang=js&"
export * from "./UpgradeModal.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeModal.vue?vue&type=style&index=0&id=d25e212c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d25e212c",
  null
  
)

export default component.exports